import * as React from 'react';

import './learningpathContainer.scss';

export default (props) => {
    const openLearningpath = () => {
        window.location.href =
            'https://eduspace.3ds.com/CompanionManager/up/?&lang=en&lpId=552&utm_source=535_5_29&utm_medium=onl_lpt&utm_campaign=P512#/lp-content';
        //    window.open('https://eduspace.3ds.com/CompanionManager/up/?&lang=en&lpId=552#/lp-content',)
    };

    const openContactUs = () => {
        window.location.href = 'https://eduspace.3ds.com/CompanionManager/public/#/LearningPortfolio';
    }

    const { setCourseMetaRef } = props;

    return (
        <div
            className="course-meta-container"
            ref={(ref) => setCourseMetaRef(ref)}
        >
            <div className="meta-item-container">
                <div className="item-body">
                    <div className="content">
                        <div className="item-title">
                            <h3>
                                Lean Management for Company’s Performance:
                                PERFORM as Lean Team Player
                            </h3>
                        </div>
                        <p>
                            The Lean learning path is part of several Learning
                            Experience libraries that must be purchased through
                            an official DS Sales channel or reseller.
                        </p>
                        <p style={{ marginTop: 20 }}>
                            In each library you will discover the value of
                            3DEXPERIENCE roles with “Explore” learning modules,
                            become proficient with “Practice” deep-dive courses,
                            earn recognition with certificates validating your
                            skills. For more information, click <i className="contact-us-link" onClick={openContactUs}>here</i>.
                        </p>
                        {/*
                        <ul className="lp-dscrp-ul">
                            <li>
                                Discover the future stakes of lean and how
                                digital lean is a key enabler for the industry
                                renaissance.
                            </li>
                            <li>
                                Learn about lean fundamentals (history,
                                concepts, methods and much more) to achieve the
                                successful transformation of your operational
                                practices.
                            </li>
                            <li>
                                Explore DMAIC (Define, Measure, Analyze,
                                Improve, Control), a key transformation
                                methodology.
                            </li>
                            <li>
                                Lead a lean transformation and establish team
                                routines in your company through learning by
                                doing courses with the <b>3D</b>EXPERIENCE platform.
                            </li>
                            <li>
                                Validate your knowledge with self-proctored
                                exams.
                            </li>
                        </ul> */}
                        {/* <div
                            className="start-expore-btn"
                            onClick={openLearningpath}
                        >
                            <img
                                className="start-expore-btn-arrow"
                                src="static/img/buttonArrow.svg"
                            />
                            Click here
                        </div> */}
                    </div>
                    <div className="thumbnail">
                        <img
                            onClick={openLearningpath}
                            alt="Perform as Lean Team Player"
                            src="./static/img/lean_thumbnail.png"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
